import { useState } from 'react';
import { useLanguage } from '@/i18n/LanguageContext';
import { ScrollReveal } from '@podus/ui';

const TOTAL = 6;

export default function FAQ() {
    const { t } = useLanguage();
    const [activeIndex, setActiveIndex] = useState(0);

    const toggle = (i: number) => setActiveIndex(activeIndex === i ? -1 : i);

    return (
        <section className="px-4 py-8 lg:px-16 lg:py-20 xl:px-20">
            <ScrollReveal variant="fade-up" distance={36} duration={800}>
                <div className="bg-[#F5F5F5] rounded-3xl px-4 lg:px-12 xl:px-16 py-10 lg:py-14 xl:py-16">
                    {/* Header */}
                    <div className="text-center lg:text-center mb-8 lg:mb-10 px-2 lg:px-0">
                        <ScrollReveal variant="blur-up" delay={100} duration={800}>
                            <h2 className="text-[28px] sm:text-[36px] lg:text-[48px] xl:text-[56px] font-extrabold text-secondary leading-[1.1] tracking-tight text-left lg:text-center">
                                {t('faq.heading')}
                            </h2>
                        </ScrollReveal>

                        <ScrollReveal variant="fade-up" delay={200}>
                            <p className="text-base lg:text-xl font-semibold mt-4 lg:mt-5 text-left lg:text-center sm:text-lg">
                                <span className="text-secondary">{t('faq.subtitle1')} </span>
                                <span className="text-primary">{t('faq.subtitle2')}</span>
                            </p>
                        </ScrollReveal>
                    </div>

                    {/* FAQ List */}
                    <div className="bg-white rounded-2xl lg:rounded-3xl">
                        {Array.from({ length: TOTAL }, (_, i) => {
                            const isOpen = activeIndex === i;
                            return (
                                <ScrollReveal key={i} variant="fade-up" delay={i * 80} distance={20}>
                                    <div className={i > 0 ? 'border-t border-gray-100' : ''}>
                                        <button
                                            type="button"
                                            className="flex items-center gap-4 lg:gap-8 w-full px-5 lg:px-10 py-5 lg:py-6 text-left cursor-pointer"
                                            onClick={() => toggle(i)}
                                        >
                                            <span
                                                className={`text-base sm:text-lg lg:text-xl font-extrabold min-w-8 sm:min-w-9 lg:min-w-11 transition-colors duration-300 ${
                                                    isOpen ? 'text-primary' : 'text-secondary'
                                                }`}
                                            >
                                                {String(i + 1).padStart(2, '0')}.
                                            </span>

                                            <span className="flex-1 text-base sm:text-lg lg:text-xl font-bold text-secondary leading-snug">
                                                {t(`faq.${i}.question`)}
                                            </span>

                                            <span className="relative w-5 h-5 flex items-center justify-center shrink-0">
                                                <span className="absolute w-3.5 h-0.5 bg-secondary rounded-full" />
                                                <span
                                                    className={`absolute w-3.5 h-0.5 bg-secondary rounded-full transition-transform duration-300 ${
                                                        isOpen ? '' : 'rotate-90'
                                                    }`}
                                                />
                                            </span>
                                        </button>

                                        <div
                                            className="grid"
                                            style={{
                                                gridTemplateRows: isOpen ? '1fr' : '0fr',
                                                transition: 'grid-template-rows 0.3s ease-out',
                                            }}
                                        >
                                            <div className="overflow-hidden">
                                                <p className="text-[#6B7280] text-sm leading-relaxed px-5 lg:px-10 pb-5 lg:pb-6 pl-14 lg:pl-27 pr-12 lg:pr-20">
                                                    {t(`faq.${i}.answer`)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </ScrollReveal>
                            );
                        })}
                    </div>
                </div>
            </ScrollReveal>
        </section>
    );
}
